import { BLOCKS_OF_COMPETENCY_TYPE_EN } from "./planningSubgroups";
import { isPersonalizedExerciseType, isSubtypeFreeExerciseType } from "./teExecutionType";

function locName(obj, stem, lng) {
  if (!obj || typeof obj !== "object") return "";
  const base = String(lng || "en").split("-")[0];
  return (
    String(obj[`${stem}${base}`] || "").trim() ||
    String(obj[`${stem}en`] || "").trim() ||
    ""
  );
}

export function cbIdFromTrainingBlock(block) {
  if (!block) return null;
  const nested = block.ex_sub_type_id;
  if (nested && typeof nested === "object") {
    return nested.cb_id || null;
  }
  if (block.competency_block?.cb_id) return block.competency_block.cb_id;
  const seqCb = block.sequences?.[0]?.competency_block?.cb_id;
  if (seqCb) return seqCb;
  const isCb =
    block.type_ex?.type_name_en === BLOCKS_OF_COMPETENCY_TYPE_EN;
  if (isCb && nested && typeof nested === "string") return nested;
  return null;
}

function uniqueSequenceSubTypeIds(block) {
  const ids = (block?.sequences || [])
    .map((seq) => seq?.sub_type_id)
    .filter(Boolean)
    .map(String);
  return [...new Set(ids)];
}

/**
 * Catalog filters so the add/exchange picker opens on the template slot's type or CB.
 */
export function catalogFilterFromTrainingBlock(block, lng = "en") {
  if (!block) {
    return { typeId: null, subTypeId: null, cbId: null, label: "", typeNameEn: "" };
  }
  const typeEx =
    block.type_ex || block.tbl_type_ex || block.capture_type_ex || null;
  const typeId = typeEx?.type_id || block.type_id || null;
  const typeNameEn = typeEx?.type_name_en || "";
  const cbId = cbIdFromTrainingBlock(block);
  const isCb =
    typeNameEn === BLOCKS_OF_COMPETENCY_TYPE_EN || Boolean(cbId);
  if (isCb && cbId) {
    const label =
      locName(block.ex_sub_type_id, "cb_name_", lng) ||
      locName(block.competency_block, "cb_name_", lng) ||
      locName(block.sequences?.[0]?.competency_block, "cb_name_", lng) ||
      locName(typeEx, "type_name_", lng);
    return { typeId, subTypeId: null, cbId, label, typeNameEn };
  }
  const seqIds = uniqueSequenceSubTypeIds(block);
  const mixedSubtypes = seqIds.length > 1;
  const subTypeId = mixedSubtypes
    ? null
    : block.sub_type_ex?.sub_type_id ||
      block.sub_type_id ||
      (typeof block.ex_sub_type_id === "object"
        ? block.ex_sub_type_id?.sub_type_id
        : null) ||
      seqIds[0] ||
      null;
  const label = mixedSubtypes
    ? locName(typeEx, "type_name_", lng)
    : locName(block.sub_type_ex, "sub_type_name_", lng) ||
      locName(block.sequences?.[0]?.sub_type_ex, "sub_type_name_", lng) ||
      locName(typeEx, "type_name_", lng);
  return { typeId, subTypeId, cbId: null, label, typeNameEn };
}

export function addExerciseNavigation(block, baseState = {}) {
  const filter = catalogFilterFromTrainingBlock(block, baseState.lng);
  const state = {
    sessionid: baseState.sessionid,
    grpid: baseState.grpid,
    tsg_id: baseState.tsg_id,
    te_id: baseState.te_id,
  };
  if (!filter.typeId && !filter.cbId) {
    return { path: "/SelectExerciseType", state };
  }
  const typeState = {
    ...state,
    typeid: filter.typeId,
    type: locName(block?.type_ex || block?.tbl_type_ex, "type_name_", baseState.lng) || filter.typeNameEn,
    type_name_en: filter.typeNameEn,
  };
  if (isPersonalizedExerciseType({ type_name_en: filter.typeNameEn })) {
    return { path: "/PersonalizedTrainingSlot", state: typeState };
  }
  if (filter.cbId) {
    return {
      path: "/Exerciseslist",
      state: {
        ...typeState,
        cbid: filter.cbId,
        cb: filter.label,
        subtypeid: filter.cbId,
        subtype: filter.label,
      },
    };
  }
  if (filter.subTypeId) {
    return {
      path: "/Exerciseslist",
      state: {
        ...typeState,
        subtypeid: filter.subTypeId,
        subtype: filter.label,
      },
    };
  }
  if (isSubtypeFreeExerciseType(block?.type_ex || block?.tbl_type_ex) || !filter.typeId) {
    return {
      path: "/Exerciseslist",
      state: { ...typeState, subtypeid: null, subtype: null },
    };
  }
  return { path: "/SelectTableExercises", state: typeState };
}
